import { FolderTypeIconEnum } from "../enums/FolderTypeIconEnum";

export class IconTypeNameResolver {
    constructor(private languageStrings: any) { }

    private iconNameDictionary = {
        [FolderTypeIconEnum.default]: this.languageStrings.Default,
        [FolderTypeIconEnum.sharepointFolder]: this.languageStrings.SharepointFolder,
        [FolderTypeIconEnum.sharepointSite]: this.languageStrings.SharepointSite,
        [FolderTypeIconEnum.documentLibrary]: this.languageStrings.SharepointDocumentLibrary,
        [FolderTypeIconEnum.oneDrive]: this.languageStrings.OneDrive,
        [FolderTypeIconEnum.teamChannel]: this.languageStrings.TeamsChannel,
        [FolderTypeIconEnum.teamMainSite]: this.languageStrings.TeamsSite,
        [FolderTypeIconEnum.teamFolder]: this.languageStrings.TeamsFolder,
        [FolderTypeIconEnum.oneDriveSubFolder]: this.languageStrings.OneDrive,
        [FolderTypeIconEnum.sharepointDocumentSet]: this.languageStrings.SharepointDocumentLibrary,
        [FolderTypeIconEnum.sharepointList]: this.languageStrings.List,
        [FolderTypeIconEnum.sharepointHubSite]: this.languageStrings.SharePointHubSite
    }

    getIconTypeName = (folderTypeIcon: FolderTypeIconEnum): string => {
        return this.iconNameDictionary[folderTypeIcon];
    }
}